import { put, takeEvery } from 'redux-saga/effects'
import { CUSTOMER_ADDRESSES_LOADING, CUSTOMER_ADDRESSES_SUCCESS, CUSTOMER_ADDRESSES_ERROR } from "../actions/actionCustomerAddresses";
import { GetCustomersAddress } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get customer addresses, response status: " + response.status + "\"}]}")
    }
}

function* GetCustomerAddresses(action) {
    try {
        let cstAddressesResponse = yield fetchAsync(GetCustomersAddress, action);
        yield put({ type: CUSTOMER_ADDRESSES_SUCCESS, payload: cstAddressesResponse });
    } catch (e) {
        yield put({ type: CUSTOMER_ADDRESSES_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaCustomerAddresses = [
    takeEvery(CUSTOMER_ADDRESSES_LOADING, GetCustomerAddresses),
];
